import { render, staticRenderFns } from "./expertExtractionAudit.vue?vue&type=template&id=fb1009f4&scoped=true"
import script from "./expertExtractionAudit.vue?vue&type=script&lang=js"
export * from "./expertExtractionAudit.vue?vue&type=script&lang=js"
import style0 from "./expertExtractionAudit.vue?vue&type=style&index=0&id=fb1009f4&prod&lang=less&scoped=true"
import style1 from "./expertExtractionAudit.vue?vue&type=style&index=1&id=fb1009f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1009f4",
  null
  
)

export default component.exports